import { useEffect } from 'react';

const SCRIPT_ID = 'am-chat-embed-script';

const isAmChatEnabled = () => String(process.env.REACT_APP_AM_CHAT_ENABLED).toLowerCase() === 'true';

const AmChatLoader = () => {
  useEffect(() => {
    if (!isAmChatEnabled()) {
      return;
    }

    const baseUrl = process.env.REACT_APP_AM_CHAT_BASE_URL;
    if (!baseUrl || document.getElementById(SCRIPT_ID)) {
      return;
    }

    window.AM_CHAT_DISABLE_AUTOMOUNT = true;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `${baseUrl}/embed.js`;
    script.async = true;
    script.onload = () => window.AmChatEmbed?.mount(undefined, { apiBaseUrl: baseUrl });
    document.body.appendChild(script);
  }, []);

  return null;
};

export { isAmChatEnabled };
export default AmChatLoader;
